var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (this.currentRange)?_c('div',{staticClass:"card help-banner",attrs:{"role":"note","aria-live":"polite"}},[_c('p',{staticClass:"help-banner__text",domProps:{"innerHTML":_vm._s(_vm.text)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }